export const UNAUTHORIZED_CODE = 401;
export const ACCESS_FORBIDDEN_CODE = 403;
export const VALIDATION_ERROR_CODE = 422;
export const INTERNAL_SERVER_ERROR_CODE = 500;
// Shared business error codes
const PAYMENT_METHOD_CARD_INVALID = 'payment-method.card.invalid';
const PAYMENT_METHOD_UNAUTHORIZED = 'payment.payment-method.unauthorized';
const PAYMENT_METHOD_NOT_FOUND = 'payment.pament-method.not-found';
const PAYMENT_METHOD_ROUTING_INVALID = 'payment.payment-method.routing-number.invalid';
const PAYMENT_METHOD_ACCOUNT_INVALID = 'payment.payment-method.account.invalid';
const PAYMENT_METHOD_TYPE_INVALID = 'payment.payment-method.type.invalid';
const PAYMENT_METHOD_ACCOUNT_LOCKED = 'payment.payment-method.account.locked';
export const PAYMENT_METHOD_BUSINESS_ERROR_CODE = {
    PAYMENT_METHOD_ACCOUNT_FAILED: 'payment-method.account.locked.letter.send-failed',
    PAYMENT_METHOD_ACCOUNT_INVALID: 'payment-method.account.invalid',
    PAYMENT_METHOD_ACCOUNT_LOCKED: 'payment-method.account.locked',
    PAYMENT_METHOD_EXIST: 'payment-method.exists',
    PAYMENT_METHOD_USER_ID_INVALID: 'payment-method.userid.invalid',
    PAYMENT_METHOD_TYPE_INVALID: 'payment-method.type.invalid',
    PAYMENT_METHOD_INVALID: 'payment-method.invalid'
};
export const PAYMENT_BUSINESS_ERROR_CODE = {
    PAYMENT_METHOD_EXPIRATION_INVALID: 'payment-method.expirationDate.invalid',
    PAYMENT_METHOD_ACCOUNT_INVALID,
    PAYMENT_METHOD_ACCOUNT_LOCKED,
    PAYMENT_METHOD_CARD_INVALID,
    PAYMENT_METHOD_NOT_FOUND,
    PAYMENT_METHOD_ROUTING_INVALID,
    PAYMENT_METHOD_TYPE_INVALID,
    PAYMENT_METHOD_UNAUTHORIZED
};
export const AUTOPAY_BUSINESS_ERROR_CODE = {
    PAYMENT_METHOD_UPDATE_RESTRICTED: 'payment-method.update.restricted',
    PAYMENT_METHOD_ACCOUNT_INVALID,
    PAYMENT_METHOD_ACCOUNT_LOCKED,
    PAYMENT_METHOD_CARD_INVALID,
    PAYMENT_METHOD_NOT_FOUND,
    PAYMENT_METHOD_ROUTING_INVALID,
    PAYMENT_METHOD_TYPE_INVALID,
    PAYMENT_METHOD_UNAUTHORIZED
};
export const DELETE_PAYMENT_METHOD_ERROR_CODE = {
    PAYMENT_METHOD_AUTOPAY_EXISTS: 'payment-method.autopay.exists',
    PAYMENT_METHOD_PAYMENT_SCHEDULED: 'payment-method.payment.scheduled.exists'
};
